import { updateInventoryCategory } from "../../api/inventoryService";

export const useUpdateInventoryCategory = (successCallback) => {
    const update = async (id, data) => {
        try {
            const updatedInventoryCategory = await updateInventoryCategory(id, data);
            if (successCallback)
            {
                successCallback(updatedInventoryCategory);
            }
            return updatedInventoryCategory;
        } catch (error) {
            console.error("Failed to update inventory category:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { update };
};